let list = document.querySelectorAll('.account-orders__grid4-list');


list.forEach(function (element) {
	element.addEventListener('mousedown', readyToMove);
});


function readyToMove(event) {
	let card = event.target.closest('.draggable');

	card.ondragstart = function () {
		return false;
	};

	$(card).on('mouseup mousemove', function handler(evt) {
		if (evt.type === 'mouseup') {
			//console.log('click', this.dataset.href);
			window.location.href = this.dataset.href;
		} else {
			//console.log('drag', evt.type);
			dragAndDropItems(card);
		}
		$(card).off('mouseup mousemove', handler);
	});
}

function dragAndDropItems(card) {
	let isZonaTarget, tabName, tabNameContain;
	//копируем элемент
	let copyElem = card.cloneNode(true);
	let copyElemId = copyElem.dataset.id;
	//Получаем размеры элемента
	let elemWidth = card.offsetWidth;
	let elemHeight = card.offsetHeight;


	//перемещать по экрану
	document.addEventListener('mousemove', onMouseMove);

	// потенциальная цель переноса, над которой мы пролетаем прямо сейчас
	let currentDroppable = null;

	function onMouseMove(event) {
		//доб класс для прозрачности элемента копию которого перемещаем
		card.classList.add('is-opacity');
		//подготовить к перемещению: разместить поверх остального содержимого и в абсолютных координатах
		copyElem.classList.add("is-moving");
		copyElem.style.width = `${elemWidth}px`;
		copyElem.style.height = `${elemHeight}px`;
		// переместим в body, чтобы был не внутри position:relative
		document.body.append(copyElem);

		// и установим абсолютно спозиционированный блок под курсор
		moveAt(copyElem, event.pageX, event.pageY);

		copyElem.hidden = true;
		let elemBelow = document.elementFromPoint(event.clientX, event.clientY);
		copyElem.hidden = false;

		// если clientX/clientY за пределами окна, elementFromPoint вернёт null
		if (!elemBelow) return;

		// потенциальные цели переноса помечены классом droppable
		let droppableBelow = elemBelow.closest('.droppable');

		//Если мы над целью и у нее есть атрибут
		if (droppableBelow != null && droppableBelow.hasAttribute('data-tabnumber')) {
			tabName = droppableBelow.getAttribute('data-tabnumber');
			isZonaTarget = true;
		} else {
			isZonaTarget = false;
		}

		tabNameContain = document.querySelectorAll(`.account-orders__content-li[data-tabnumber="${tabName}"]`);

		if (currentDroppable != droppableBelow) {
			// мы либо залетаем на цель, либо улетаем из неё/внимание: оба значения могут быть null
			//   currentDroppable=null, если мы были не над droppable до этого события (например, над пустым пространством)
			//   droppableBelow=null, если мы не над droppable именно сейчас, во время этого события

			if (currentDroppable) {
				// логика процесса "вылета" из droppable (удаляем подсветку)
				leaveDroppable(currentDroppable);
			}

			currentDroppable = droppableBelow;

			if (currentDroppable) {
				// логика процесса, когда мы "влетаем" в элемент droppable
				enterDroppable(currentDroppable);
			}
		}
	}

	function moveAt(copyElem, pageX, pageY) {
		// передвинуть блок под координаты курсора и сдвинуть на половину ширины/высоты для центрирования
		copyElem.style.left = pageX - copyElem.offsetWidth / 2 + 'px';
		copyElem.style.top = pageY - copyElem.offsetHeight / 2 + 'px';
	}

	// положить. удалить более ненужные обработчики событий
	copyElem.addEventListener('mouseup', function putCard() {

		document.removeEventListener('mousemove', onMouseMove);
		copyElem.onmouseup = null;

		if (isZonaTarget) {
			tabNameContain[0].childNodes[1].childNodes[1].childNodes[1].prepend(this);
			copyElem.classList.remove("is-moving");
			copyElem.removeEventListener('mouseup', putCard);
			copyElem.removeAttribute("style");
			card.remove();
			leaveDroppable(currentDroppable);

			//send to server
			sendId(copyElemId, tabName);

		} else {
			copyElem.remove();
			card.classList.remove('is-opacity');
		}
	});

	function enterDroppable(elem) {
		elem.classList.add('is-hover');
	}

	function leaveDroppable(elem) {
		elem.classList.remove('is-hover');
	}
};



function sendId(id, section) {
	let dataUrl = document.querySelector('.account-orders__nav').dataset.url;
	let obj = {
		id: Number(id),
		section: section,
	}

	if (dataUrl === null || dataUrl === '') {
		return false;
	}

	$.ajax({
		url: `${dataUrl}`,
		type: 'POST',
		data: { id: obj.id, section: obj.section },
	});
}